import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { FormField, FormFields } from '../../../components/FormFields';
import { Button } from '../../../components/Buttons';
import { HBox, VBox } from '../../../components/Box';
import DatePicker from 'react-datepicker';
import {
  addInvoiceSubject,
  addRelationSource,
  calculateFinancialAmounts,
  createCreditInvoice,
  declineInvoice,
  deleteInvoice,
  exportInvoiceToExact,
  fetchInvoice,
  finalizeV2,
  getExactAuthStatus,
  removeInvoiceSubject,
  removeRelationSource,
  retryFinalizationV2,
  syncBpm,
  updateInvoice,
  updateInvoiceDate,
  updateInvoiceEmailData,
  updateInvoiceOutgoingBpm,
  updateInvoiceStatus,
  updateInvoiceSubject,
} from '../actions';
import { Content } from '../../../components/Content';
import { Input } from '../../../components/Form';
import { Check, Plus, Times } from '../../../components/Icon';
import { Modal, ModalControls } from '../../../components/Modal';
import { CompanySelection } from '../../Companies/components/CompanySelection';
import { DirectionSelection } from '../components/DirectionSelection';
import { TypeSelection } from '../components/TypeSelection';
import { StatusSelection } from '../components/StatusSelection';
import { InvoiceStatus } from '../components/InvoiceStatus';
import { Checkbox } from '../../../components/Checkbox';
import { InvoiceSubjectContainer } from '../components/InvoiceSubject/InvoiceSubjectContainer';
import { selectInvoice, selectAutotelexBPM } from '../selectors';
import { getCurrentRestBpm } from '../actions';
import { setVehicleProperties, updateRestBpmRequest } from '../../Vehicles/actions';
import { InvoiceRelationSourceContainer } from '../components/InvoiceRelationSourceContainer';
import { InvoiceStructureCard } from '../components/CardInvoiceStructure';
import { InvoiceQuizModal } from '../components/InvoiceQuizModal';
import { selectConfig, selectWork } from '../../Api/selectors';
import {
  BtwOrMarge,
  FINALIZATION_STATUSES,
  INVOICE_DIRECTIONS,
  INVOICE_SUBJECT_TYPES,
  INVOICE_TYPES,
  REQUEST_CREATE_CREDIT_INVOICE,
  REQUEST_EXACT_AUTH_STATUS,
  REQUEST_EXACT_EXPORT_INVOICE,
  REQUEST_INVOICE,
  REQUEST_INVOICE_DECLINE,
  REQUEST_INVOICE_DELETE,
  REQUEST_SYNC_BPM,
  REQUEST_UPDATE_INVOICE_OUTGOING_BPM,
} from '../constants';
import { Loader } from '../../../components/Loader';
import { FieldError } from '../../../components/FieldError';
import _ from 'lodash';
import { InvoiceTransportLocation } from '../components/InvoiceTransportLocation/InvoiceTansportLocation';
import { addApiError } from '../../Api/actions';
import { LedgersPosting } from '../components/Ledgers/LedgersPosting';
import { DeclineInvoiceModal } from '../components/DeclineInvoiceModal';
import { BpmWarningModal } from '../components/BpmWarningModal';
import { DeleteInvoiceModal } from '../components/DeleteInvoiceModal';
import { CreditInvoiceModal } from '../components/CreditInvoiceModal';
import dayjs from 'dayjs';
import { Permission } from '../../../components/Permission';
import { INVOICE_DELETE, INVOICE_EDIT } from '../../../components/Permission/constants';
import { selectVehicle } from '../../Vehicles/selectors';
import { ViesCheckPrompt } from '../components/ViesCheckPrompt';
import { checkVies } from '../../Companies/actions';
import { REQUEST_VIES_CHECK } from '../../Companies/constants';
import { PaymentsLog } from '../components/PaymentsLog';
import { InvoiceFinalizationStatusBar } from '../components/InvoiceFinalizationStatusBar';
import { getFinalizationStatus } from '../helpers';
import { OutgoingBPMModal } from '../components/OutgoingBPMModal';
import { ProductSubjectDetails } from '../../products/components/ProductSubjectDetails';
import { ProductInvoiceEmailModal } from '../../products/components/productInvoiceEmailModal';
import { AUTOHUISSALLAND_INSTALATION } from '../../../containers/App/constants';
import { LoadingWithNotification } from '../../../components/LoadingWithNotification/LoadingWithNotification';

const Container = styled.div``;
const Link = styled.a`
  text-decoration: underline;
  font-size: 20px;
`;

const Row = styled.div`
  border: solid 1px;
  //margin-top: 4px;
  margin-bottom: 8px;
  width: auto;
  padding: 0 5px;
  .row-title {
    margin-left: 5px;
    font-size: 18px;
  }
`;

const STATE = {
  incomingCompanyEdit: false,
  selectedCompanyId: null,
  selectedCompanyLabel: null,
  selectedCompanyBtwNumber: null,
  outgoingCompanyEdit: false,
  directionEdit: false,
  selectedDirection: null,
  selectedDirectionLabel: null,
  typeEdit: false,
  selectedType: null,
  selectedTypeLabel: null,
  statusEdit: false,
  selectedStatus: null,
  selectedStatusLabel: null,
  creatorEdit: false,
  showDeclineModal: false,
  bpmWarningModal: false,
  showDeleteModal: false,
  showCreditModal: false,
  showConfirmBpmModal: false,
  showViesCheckPrompt: false,
  bpmUpdateModal: false,
  showQuizCredit: false,
  showQuizDelete: false,
  showEmailModal: false,
  extraComment: null,
};

/* eslint-disable react/prefer-stateless-function */
class InvoiceDetailsComp extends BaseComponent {
  constructor(props) {
    super(props, { ..._.cloneDeep(STATE) });
  }

  componentDidMount() {
    this.props.fetchInvoice();
    // this.props.syncBpm();
  }

  getFieldValue(fieldName) {
    if (Object.keys(this.state).includes(fieldName)) {
      return this.state[fieldName];
    }
    return this.props.invoice[fieldName];
  }

  get invoice() {
    return this.props.invoice;
  }

  onDateChange(value) {
    let date = dayjs(value).format('YYYY-MM-DD hh:mm:ss');
    this.updateState('date', date);
    return this;
  }

  onDueDateChange(value) {
    let date = dayjs(value).format('YYYY-MM-DD hh:mm:ss');
    this.updateState('dueDate', date);
    return this;
  }

  onPaidDateChange(value) {
    let date = dayjs(value).format('YYYY-MM-DD hh:mm:ss');
    this.updateState('paidDate', date);
    return this;
  }

  onDesiredDeliveryDateChange(value) {
    let date = dayjs(value).format('YYYY-MM-DD hh:mm:ss');
    this.updateState('desiredDeliveryDate', date);
    return this;
  }

  get applyDisabled() {
    return !!this.props.invoice.finalizationStatus;
  }

  get dto() {
    let isFinal = this.getFieldValue('isFinal');
    const referenceNumber = this.getFieldValue('referenceNumber');
    const direction = this.getFieldValue('direction');

    if (direction === INVOICE_DIRECTIONS.INCOMING && !referenceNumber) {
      isFinal = false;
    }

    return {
      date: this.getFieldValue('date'),
      desiredDeliveryDate: this.getFieldValue('desiredDeliveryDate'),
      direction,
      discount: this.getFieldValue('discount'),
      dueDate: this.getFieldValue('dueDate'),
      economicalTotalAmount: this.getFieldValue('economicalTotalAmount'),
      exclVat: this.getFieldValue('exclVat'),
      financialTotalAmount: this.getFieldValue('financialTotalAmount'),
      isFinal,
      paidDate: this.getFieldValue('paidDate'),
      payments: this.getFieldValue('payments'),
      incoming: this.getFieldValue('incoming'),
      statusId: this.getFieldValue('status'),
      type: this.getFieldValue('type'),
      userCreatorId: this.getFieldValue('userCreatorId'),
      incomingCompanyId: this.getFieldValue('incomingCompanyId'),
      outgoingCompanyId: this.getFieldValue('outgoingCompanyId'),
      transportLocationId: this.getFieldValue('transportLocation')?.id ?? null,
      referenceNumber,
      invoiceAddittionalLines: [this.getFieldValue('extraComment')],
    };
  }

  onViesCheck() {
    const direction = this.getFieldValue('direction');
    const company =
      direction === INVOICE_DIRECTIONS.INCOMING ? this.props.invoice?.incomingCompany : this.props.invoice?.outgoingCompany;
    const btwState =
      direction === INVOICE_DIRECTIONS.INCOMING ? this.state.incoming_btw_number : this.state.outgoing_btw_number;
    const btw_number = btwState || company?.BTW_number;

    const dto = {
      id: company?.id,
      entity: 'company',
      countryCode: btw_number?.substring(0, 2),
      vatCode: btw_number?.substring(2),
    };
    this.props.checkViesStatus(dto, result => {
      if (result?.valid) {
        this.onUpdate();
        return;
      }
      this.setState({ showViesCheckPrompt: true });
    });
  }

  onUpdate() {
    this.props.update(this.dto);

    if (this.state.getViesCheck && this.state.isFinal && this.invoice?.subjectType !== INVOICE_SUBJECT_TYPES.BPM) {
      this.setState({ showViesCheckPrompt: false, getViesCheck: false, isFinal: false });
    }
  }

  onEditCreator() {
    this.setState(prev => {
      return { ...prev, creatorEdit: true };
    });
  }

  onEditIncomingCompany() {
    this.setState(prev => {
      return { ...prev, incomingCompanyEdit: true };
    });
  }

  onEditOutgoingCompany() {
    this.setState(prev => {
      return { ...prev, outgoingCompanyEdit: true };
    });
  }

  onEditDirection() {
    this.setState(prev => {
      return { ...prev, directionEdit: true };
    });
  }

  onEditType() {
    this.setState(prev => {
      return { ...prev, typeEdit: true };
    });
  }

  onEditStatus() {
    this.setState(prev => {
      return { ...prev, statusEdit: true };
    });
  }

  onChangeCompanySelection(company) {
    this.setState(prev => {
      return {
        ...prev,
        selectedCompanyLabel: company.name ?? company.name ?? '',
        selectedCompanyId: company.id,
        selectedCompanyBtwNumber: company?.BTW_number,
      };
    });
  }

  onChangeDirectionSelection(direction) {
    this.setState(prev => {
      return { ...prev, selectedDirectionLabel: direction.label, selectedDirection: direction.id };
    });
  }

  onChangeTypeSelection(type) {
    this.setState(prev => {
      return { ...prev, selectedTypeLabel: type.label, selectedType: type.id };
    });
  }

  onChangeStatusSelection(status) {
    this.setState(prev => {
      return { ...prev, selectedStatusLabel: status.label, selectedStatus: status.id };
    });
  }

  onChangeIncomingCompany() {
    this.setState(prev => {
      return {
        ...prev,
        incomingCompanyLabel: prev.selectedCompanyLabel,
        incomingCompanyId: prev.selectedCompanyId,
        incoming_btw_number: prev.selectedCompanyBtwNumber,
        incomingCompanyEdit: false,
        selectedCompanyId: null,
        selectedCompanyLabel: null,
        selectedCompanyBtwNumber: null,
      };
    });
  }

  onChangeOutgoingCompany() {
    this.setState(prev => {
      return {
        ...prev,
        outgoingCompanyLabel: prev.selectedCompanyLabel,
        outgoingCompanyId: prev.selectedCompanyId,
        outgoing_btw_number: prev.selectedCompanyBtwNumber,
        outgoingCompanyEdit: false,
        selectedCompanyId: null,
        selectedCompanyLabel: null,
        selectedCompanyBtwNumber: null,
      };
    });
  }

  onChangeDirection() {
    this.setState(prev => {
      return {
        ...prev,
        directionLabel: prev.selectedDirectionLabel,
        direction: prev.selectedDirection,
        directionEdit: false,
        selectedDirection: null,
        selectedDirectionLabel: null,
      };
    });
  }

  onChangeType() {
    this.setState(prev => {
      return {
        ...prev,
        typeLabel: prev.selectedTypeLabel,
        type: prev.selectedType,
        typeEdit: false,
        selectedType: null,
        selectedTypeLabel: null,
      };
    });
  }

  onChangeStatus() {
    this.props.updateInvoiceStatus(this.state.selectedStatus, () => {
      this.setState(prev => {
        return {
          ...prev,
          statusLabel: prev.selectedStatusLabel,
          status: prev.selectedStatus,
          statusEdit: false,
          selectedStatus: null,
          selectedStatusLabel: null,
        };
      });
    });
  }

  onResetIncomingUser() {
    this.setState(prev => {
      return { ...prev, incomingUserLabel: null, incomingUserId: null };
    });
  }

  onResetIncomingCompany() {
    this.setState(prev => {
      return { ...prev, incomingCompanyLabel: null, incomingCompanyId: null };
    });
  }

  onResetOutgoingCompany() {
    this.setState(prev => {
      return { ...prev, outgoingCompanyLabel: null, outgoingCompanyId: null };
    });
  }

  onResetDirection() {
    this.setState({ directionLabel: null, direction: null });
  }

  onResetType() {
    this.setState(prev => {
      return { ...prev, typeLabel: null, type: null };
    });
  }

  onResetStatus() {
    this.setState(prev => {
      return { ...prev, statusLabel: null, status: null };
    });
  }

  closeIncomingCompanyEdit() {
    this.setState(prev => {
      return { ...prev, incomingCompanyEdit: false, selectedCompanyId: null, selectedCompanyLabel: null };
    });
  }

  closeOutgoingCompanyEdit() {
    this.setState(prev => {
      return { ...prev, outgoingCompanyEdit: false, selectedCompanyId: null, selectedCompanyLabel: null };
    });
  }

  closeDirectionEdit() {
    this.setState(prev => {
      return { ...prev, directionEdit: false, selectedDirection: null, selectedDirectionLabel: null };
    });
  }

  closeTypeEdit() {
    this.setState(prev => {
      return { ...prev, typeEdit: false, selectedType: null, selectedTypeLabel: null };
    });
  }

  closeStatusEdit() {
    this.setState(prev => {
      return { ...prev, statusEdit: false, selectedStatus: null, selectedStatusLabel: null };
    });
  }

  onIsFinalChanged() {
    if (this.getFieldValue('direction') === INVOICE_DIRECTIONS.INCOMING && !this.getFieldValue('referenceNumber')) {
      this.props.showError('Field Payment reference Nr must not be empty for incoming invoice');
      return;
    }
    if (!this.state.isFinal) {
      // this.syncRestBpm(true);
      this.setState({ getViesCheck: true });
    }

    if (this.state.isFinal) {
      this.setState({ getViesCheck: false });
    }

    this.setState(prev => {
      return { ...prev, isFinal: !prev.isFinal };
    });
  }

  onExclVatChanged() {
    this.setState(prev => {
      return { ...prev, exclVat: !prev.exclVat };
    });
  }

  reset() {
    this.setState(
      { ...this.props.invoice, getViesCheck: false, showViesCheckPrompt: false } ?? {
        getViesCheck: false,
        showViesCheckPrompt: false,
      },
    );
  }

  renderCreator() {
    if (this.getFieldValue('creatorId')) {
      return (
        <HBox>
          <p>{this.getFieldValue('creatorLabel') ?? ''}</p>
        </HBox>
      );
    }

    return <Plus onClick={this.onEditCreator.bind(this)} />;
  }

  renderIncomingCompany() {
    if (this.getFieldValue('incomingCompanyId')) {
      return (
        <HBox>
          <p>{this.getFieldValue('incomingCompanyLabel') ?? ''}</p>
          <Times onClick={this.onResetIncomingCompany.bind(this)} />
        </HBox>
      );
    }

    return <Plus onClick={this.onEditIncomingCompany.bind(this)} />;
  }

  renderOutgoingCompany() {
    if (this.getFieldValue('outgoingCompanyId')) {
      return (
        <HBox>
          <p>{this.getFieldValue('outgoingCompanyLabel') ?? ''}</p>
          <Times onClick={this.onResetOutgoingCompany.bind(this)} />
        </HBox>
      );
    }

    return <Plus onClick={this.onEditOutgoingCompany.bind(this)} />;
  }

  renderDirection() {
    if (this.getFieldValue('directionLabel')) {
      return (
        <HBox>
          <p>{this.getFieldValue('directionLabel') ?? ''}</p>
          <Times onClick={this.onResetDirection.bind(this)} />
        </HBox>
      );
    }

    return <Plus onClick={this.onEditDirection.bind(this)} />;
  }

  renderType() {
    if (this.getFieldValue('typeLabel')) {
      return (
        <HBox>
          <p>{this.getFieldValue('typeLabel') ?? ''}</p>
          <Times onClick={this.onResetType.bind(this)} />
        </HBox>
      );
    }

    return <Plus onClick={this.onEditType.bind(this)} />;
  }

  renderStatus() {
    if (this.getFieldValue('statusLabel')) {
      return (
        <HBox onClick={this.onEditStatus.bind(this)}>
          <InvoiceStatus status={this.getFieldValue('statusLabel')} />
          {/*<Times onClick={this.onResetStatus.bind(this)} />*/}
        </HBox>
      );
    }

    return <Plus onClick={this.onEditStatus.bind(this)} />;
  }

  renderDeclined() {
    return (
      <VBox>
        <p>{this.lbl('invoice.create.isDeclined')}</p>
        <Checkbox checked={!!this.getFieldValue('creditInvoiceId')}></Checkbox>
      </VBox>
    );
  }

  renderIncomingCompanyEdit() {
    if (!this.getFieldValue('incomingCompanyEdit')) return '';

    return (
      <Modal title={this.lbl('confirm')}>
        {this.state.selectedCompanyId ? (
          <VBox>{this.state.selectedCompanyLabel}</VBox>
        ) : (
          <CompanySelection
            order
            user={{ id: this.getFieldValue('incomingCompanyId') }}
            onSelect={this.onChangeCompanySelection.bind(this)}
          />
        )}
        <ModalControls>
          <Button onClick={this.onChangeIncomingCompany.bind(this)}>{this.lbl('add')}</Button>
          <Button onClick={this.closeIncomingCompanyEdit.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  renderOutgoingCompanyEdit() {
    if (!this.getFieldValue('outgoingCompanyEdit')) return '';

    return (
      <Modal title={this.lbl('confirm')}>
        {this.getFieldValue('selectedCompanyId') ? (
          <VBox>{this.getFieldValue('selectedCompanyLabel')}</VBox>
        ) : (
          <CompanySelection
            invoiceCompany
            user={{ id: this.getFieldValue('incomingCompanyId') }}
            onSelect={this.onChangeCompanySelection.bind(this)}
          />
        )}
        <ModalControls>
          <Button onClick={this.onChangeOutgoingCompany.bind(this)}>{this.lbl('add')}</Button>
          <Button onClick={this.closeOutgoingCompanyEdit.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  renderDirectionEdit() {
    if (!this.getFieldValue('directionEdit')) return '';

    return (
      <Modal title={this.lbl('confirm')}>
        {this.state.selectedDirection ? (
          <VBox>{this.state.selectedDirectionLabel}</VBox>
        ) : (
          <DirectionSelection onSelect={this.onChangeDirectionSelection.bind(this)} />
        )}
        <ModalControls>
          <Button onClick={this.onChangeDirection.bind(this)}>{this.lbl('add')}</Button>
          <Button onClick={this.closeDirectionEdit.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  renderTypeEdit() {
    if (!this.getFieldValue('typeEdit')) return '';

    return (
      <Modal title={this.lbl('confirm')}>
        {this.state.selectedType ? (
          <VBox>{this.state.selectedTypeLabel}</VBox>
        ) : (
          <TypeSelection onSelect={this.onChangeTypeSelection.bind(this)} />
        )}
        <ModalControls>
          <Button onClick={this.onChangeType.bind(this)}>{this.lbl('add')}</Button>
          <Button onClick={this.closeTypeEdit.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  renderStatusEdit() {
    if (!this.state.statusEdit) return '';
    if (!this.props.serverConfig.manualPaymentStatus) return this.renderStatusEditStub();

    return (
      <Modal title={this.lbl('invoice.invoice_status')}>
        {this.state.selectedStatus ? (
          <VBox>{this.lbl('translate.' + this.state.selectedStatusLabel)}</VBox>
        ) : (
          <StatusSelection onSelect={this.onChangeStatusSelection.bind(this)} />
        )}
        <ModalControls>
          <Button onClick={this.onChangeStatus.bind(this)}>{this.lbl('update')}</Button>
          <Button onClick={this.closeStatusEdit.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  renderStatusEditStub() {
    return (
      <Modal title={this.lbl('status')}>
        {this.lbl('invoice.statusEditStubMsg')}
        <ModalControls>
          <Button onClick={this.closeStatusEdit.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  onSaveSubject(subject) {
    const subjectId = subject.id;
    if (!subjectId) {
      this.props.addInvoiceSubject(subject);
      return;
    }

    this.props.updateInvoiceSubject(subject, subjectId);
  }

  onDeleteSubject(subjectId) {
    this.props.removeInvoiceSubject(subjectId, data => {
      if (Array.isArray(data.invoiceSubjects)) {
        this.setState((prev, props) => {
          return { ...prev, invoiceSubjects: data.invoiceSubjects };
        });
      }
    });
  }

  onAddSource(source) {
    this.props.addRelationSource(source, data => {
      if (Array.isArray(data.relationSources)) {
        this.setState((prev, props) => {
          return { ...prev, relationSources: data.relationSources };
        });
      }
    });
  }

  onDeleteSource(sourceId) {
    this.props.removeRelationSource(sourceId, data => {
      if (Array.isArray(data.relationSources)) {
        this.setState((prev, props) => {
          return { ...prev, relationSources: data.relationSources };
        });
      }
    });
  }

  get exactIsAuthenticated() {
    return this.state.exactAuthStatus;
  }

  get exportBtnDisabled() {
    return !!this.invoice.exportedAt;
  }

  get exportedAtMsg() {
    // Show old message if an invoice has been exported with an old flow
    if (this.props.invoice.exportedAt && !this.invoice.finalizationStatus) {
      return (
        <p>
          {this.lbl('invoice.details.exportedStatus')} {this.invoice.exportedAt}
        </p>
      );
    }
    return <InvoiceFinalizationStatusBar invoice={this.invoice} />;
  }

  get notReadyToExportMsg() {
    return !this.exactIsAuthenticated ? <FieldError errors={[this.lbl('invoice.details.notReadyToExportMsg')]} /> : '';
  }

  getExactAuthStatus() {
    this.props.getExactAuthStatus(data => {
      this.setState((prev, props) => {
        return { ...prev, exactAuthStatus: data };
      });
    });
  }

  exportInvoiceToExact() {
    if (this.needToUpdateOutgoingBPM) {
      this.setState({ bpmUpdateModal: true });
      return;
    }

    this.props.exportInvoiceToExact();
  }

  finalizeV2() {
    const emailIsOptional = !![AUTOHUISSALLAND_INSTALATION.APP_CLIENT_ID].includes(this.props.serverConfig.appClientId);
    if (
      !this.invoice.emailTo &&
      !this.invoice.emailContactId &&
      !this.invoice.financialContactId &&
      this.invoice.direction === INVOICE_DIRECTIONS.OUTGOING &&
      this.invoice?.subjectType !== 'BPM' &&
      !emailIsOptional
    ) {
      this.setState({ showEmailModal: true });
      return;
    }

    if (this.needToUpdateOutgoingBPM) {
      this.setState({ bpmUpdateModal: true });
      return;
    }

    this.props.finalizeV2();
  }

  onEmailModalComplete(dto) {
    this.setState({ showEmailModal: false }, () => {
      this.props.updateInvoiceEmailData(dto, response => {
        if (response.validationErrors) {
          let errorMsg = 'general';
          if (response.validationErrors) {
            errorMsg = Object.values(response.validationErrors[0]?.constraints ?? {})[0] ?? '';
          }
          this.props.addApiError(errorMsg);
        } else {
          this.props.finalizeV2();
        }
      });
    });
  }

  get needToUpdateOutgoingBPM() {
    if (this.props.serverConfig?.disableBPM) return false;
    if (this.invoice?.type !== 'invoice') return false;

    return (
      this.invoice?.direction === 'outgoing' &&
      ((this.invoice?.subjectType === 'vehicle' && !this.invoice.ledgersEntry.needBPMInvoice) ||
        this.invoice?.subjectType === 'BPM') &&
      !this.invoice?.vehicle?.new_from_factory &&
      this.invoice?.vehicle?.vehiclePurpose !== 'commercial' &&
      this.invoice?.vehicle?.financialAmounts?.rest_bpm != 0
    );
  }

  renderCompany() {
    switch (this.getFieldValue('direction')) {
      case INVOICE_DIRECTIONS.INCOMING:
        return (
          <VBox>
            <p>{this.lbl('invoice.create.incomingCompany')}</p>
            <FormField>{this.renderIncomingCompany()}</FormField>
          </VBox>
        );
      case INVOICE_DIRECTIONS.OUTGOING:
        return (
          <VBox>
            <p>{this.lbl('invoice.create.outgoingCompany')}</p>
            <FormField>{this.renderOutgoingCompany()}</FormField>
          </VBox>
        );
      default:
        return <VBox></VBox>;
    }
  }

  onChangeTransportLocation(transportLocation) {
    this.setState(prev => {
      return { ...prev, transportLocation };
    }, this.onUpdate.bind(this));
  }

  renderTransportLocationSection() {
    const direction = this.getFieldValue('direction');
    let companyId = null;
    if (INVOICE_DIRECTIONS.INCOMING === direction) companyId = this.getFieldValue('incomingCompanyId');
    if (INVOICE_DIRECTIONS.OUTGOING === direction) companyId = this.getFieldValue('outgoingCompanyId');
    if (!companyId) return '';

    return (
      <HBox flip={window.innerWidth <= 768}>
        <VBox>
          <p>{this.lbl('invoice.create.transportLocation')}</p>
          <FormField>
            <InvoiceTransportLocation
              onChange={this.onChangeTransportLocation.bind(this)}
              transportLocation={this.getFieldValue('transportLocation')}
              companyId={companyId}
            />
          </FormField>
        </VBox>
      </HBox>
    );
  }

  renderExportSection() {
    return (
      <VBox>
        <FormField>{this.renderFinalizeBtn()}</FormField>
        {this.exportedAtMsg}
      </VBox>
    );
  }

  renderFinalizeBtn() {
    const finalize = () => {
      if (!this.invoice?.vehicle?.regplate && !this.invoice?.vehicle?.import && this.state.acceptNonImport !== 'yes') {
        this.setState({ showNonImportNotification: true });
        return;
      }

      this.props.finalizeV2();
    };

    if (this.state.showNonImportNotification) {
      return (
        <Modal mediumWide onClose={() => this.setState({ showNonImportNotification: false, acceptNonImport: null })}>
          <strong>{this.lbl('invoice.overview.non_import_notification')}</strong>
          <ModalControls>
            <Button
              style={{ marginRight: '5px' }}
              small
              onClick={() => this.setState({ acceptNonImport: 'yes', showNonImportNotification: false }, () => finalize())}
            >
              {this.lbl('yes')}
            </Button>
            <Button small onClick={() => this.setState({ showNonImportNotification: false, acceptNonImport: null })}>
              {this.lbl('cancel')}
            </Button>
          </ModalControls>
        </Modal>
      );
    }

    // Show old button if invoice has been finalized with an old flow
    if (this.invoice.isFinal && !this.invoice.finalizationStatus)
      return (
        <Button disabled={this.exportBtnDisabled} onClick={this.exportInvoiceToExact.bind(this)}>
          {this.lbl('invoice.details.exportBtn')}
        </Button>
      );
    const status = getFinalizationStatus(this.props.invoice);
    if (FINALIZATION_STATUSES.READY_TO_INITIATE === status)
      return <Button onClick={() => finalize()}>{this.lbl('invoice.details.finalizeV2Btn')}</Button>;

    if (FINALIZATION_STATUSES.DONE === status)
      return (
        <Button disabled={true} onClick={() => finalize()}>
          {this.lbl('invoice.details.finalizeV2Btn')}
        </Button>
      );

    if (FINALIZATION_STATUSES.IN_PROGRESS === status)
      return (
        <Button disabled={true} onClick={() => finalize()}>
          {this.lbl('invoice.details.finalizeV2Btn')}
        </Button>
      );

    if (FINALIZATION_STATUSES.ERROR === status)
      return (
        <Button onClick={this.props.retryFinalizationV2.bind(this)}>{this.lbl('invoice.details.retryFinalizeV2Btn')}</Button>
      );

    return '';
  }

  showCreditModal() {
    this.setState({ showCreditModal: true });
  }

  get showCreditButton() {
    return !!this.invoice.exportedAt && this.invoice.type !== INVOICE_TYPES.CREDIT;
  }

  renderCreditModal() {
    return (
      this.state.showCreditModal && (
        <CreditInvoiceModal
          onConfirm={this.onConfirmCreditModal.bind(this)}
          onCancel={this.onCancelCreditModal.bind(this)}
        />
      )
    );
  }

  onConfirmCreditModal() {
    let showQuizCredit = false;
    if (this.invoice.subjectType === INVOICE_SUBJECT_TYPES.VEHICLE) showQuizCredit = true;
    if (!showQuizCredit) {
      this.setState({ showCreditModal: false }, this.sendCreditRequest([]));
    } else {
      this.setState({ showQuizCredit, showCreditModal: false });
    }
  }

  sendCreditRequest = properties => {
    this.setState(
      { showQuizCredit: false },
      this.props.createCreditInvoice(properties, result => {
        if (typeof result === 'number') {
          this.to(`/invoices/${result}`);
        }
      }),
    );
  };

  onCancelQuiz = () => {
    this.setState({ showQuizCredit: false, showQuizDelete: false });
  };

  onCancelCreditModal() {
    this.setState({ showCreditModal: false });
  }

  renderCreditSection() {
    if (this.showCreditButton)
      return (
        <VBox>
          <FormField>
            <Button warning={true} onClick={this.showCreditModal.bind(this)}>
              {this.lbl('invoice.details.creditBtn')}
            </Button>
          </FormField>
          {this.renderCreditModal()}
        </VBox>
      );

    return '';
  }

  showDeclineModal() {
    this.setState({ showDeclineModal: true });
  }

  renderDeclineSection() {
    return;
    if (this.showDeclineButton)
      return (
        <VBox>
          <FormField>
            <Button warning={true} onClick={this.showDeclineModal.bind(this)}>
              {this.lbl('invoice.details.declineBtn')}
            </Button>
          </FormField>
          {this.renderDeclineModal()}
        </VBox>
      );

    return '';
  }

  onConfirmDeclineModal() {
    this.setState({ showDeclineModal: false }, this.props.declineInvoice);
  }

  onCancelDeclineModal() {
    this.setState({ showDeclineModal: false });
  }

  renderDeclineModal() {
    return (
      this.state.showDeclineModal && (
        <DeclineInvoiceModal
          onConfirm={this.onConfirmDeclineModal.bind(this)}
          onCancel={this.onCancelDeclineModal.bind(this)}
        />
      )
    );
  }

  get showDeclineButton() {
    return !!this.invoice.isFinal;
  }

  renderDeleteSection() {
    if (this.showDeleteButton)
      return (
        <VBox>
          <FormField>
            <Button warning={true} onClick={this.showDeleteModal}>
              {this.lbl('invoice.details.deleteBtn')}
            </Button>
          </FormField>
          {this.renderDeleteModal()}
        </VBox>
      );

    return '';
  }

  get showDeleteButton() {
    return !this.invoice.isFinal;
  }

  showDeleteModal = () => {
    this.setState({ showDeleteModal: true });
  };

  onConfirmDeleteModal() {
    let showQuizDelete = false;
    if (this.invoice.subjectType === INVOICE_SUBJECT_TYPES.VEHICLE) showQuizDelete = false;
    if (!showQuizDelete) {
      this.setState({ showDeleteModal: false }, this.sendDeleteRequest([]));
    } else {
      this.setState({ showDeleteModal: false, showQuizDelete });
    }
  }

  onCancelDeleteModal() {
    this.setState({ showDeleteModal: false });
  }

  sendDeleteRequest = properties => {
    const vehicleId = this.invoice?.vehicle?.id;
    this.setState({ showQuizDelete: false }, this.props.deleteInvoice(properties, this.redirectAfterDelete, vehicleId));
  };

  renderDeleteModal() {
    return (
      this.state.showDeleteModal && (
        <DeleteInvoiceModal
          onConfirm={this.onConfirmDeleteModal.bind(this)}
          onCancel={this.onCancelDeleteModal.bind(this)}
        />
      )
    );
  }

  redirectAfterDelete = () => {
    if (this.invoice?.vehicle?.id) {
      return this.to(`/vehicles/${this.invoice?.vehicle?.id}`);
    } else {
      return this.to(`/invoices`);
    }
  };

  get vehicleSubject() {
    const subjects = this.invoice.invoiceSubjects ?? [];
    if (!subjects.length) return null;
    return subjects.find(s => INVOICE_SUBJECT_TYPES.VEHICLE === s.type);
  }

  get showSyncBPMBtn() {
    const vehicleSubject = this.vehicleSubject;
    if (!vehicleSubject) return false;
    const vehicle = vehicleSubject.vehicle;
    if (!vehicle) return false;
    return (
      !(vehicle?.financialAmounts?.rest_bpm === vehicleSubject.rest_bpm) ||
      !(vehicle?.financialAmounts?.financial_bpm_gross === vehicleSubject.financial_bpm_gross)
    );
  }

  onSyncBpm() {
    this.props.syncBpm();
  }

  get syncBpmDisabled() {
    return this.invoice.isFinal;
  }

  renderSyncBpmSection() {
    return (
      <VBox>
        <FormField>
          <Button warning={true} onClick={this.onSyncBpm.bind(this)}>
            {this.lbl('invoice.details.syncBpmBtn')}
          </Button>
        </FormField>
      </VBox>
    );
  }

  needToShowBpmWarning() {
    const vehicleSubject = this.vehicleSubject;
    if (!vehicleSubject) return false;
    const vehicle = vehicleSubject?.vehicle;
    if (!vehicle) return false;
    if (vehicle.vehiclePurpose === 'commercial') return false;
    return !vehicleSubject.rest_bpm || !vehicleSubject.financial_bpm_gross;
  }

  onCancelBpmWarning() {
    this.setState({ bpmWarningModal: false });
  }

  onChangeComment(evt) {
    this.setState({ extraComment: evt.target.value });
  }

  bpmWarningOnConfirm() {
    this.setState({ bpmWarningModal: false });
    this.props.exportInvoiceToExact();
  }

  renderBpmWarningModal() {
    return (
      this.state.bpmWarningModal && (
        <BpmWarningModal onConfirm={this.bpmWarningOnConfirm.bind(this)} onCancel={this.onCancelBpmWarning.bind(this)} />
      )
    );
  }

  renderAttachedVehicle() {
    if (!this.invoice.vehicle) {
      return <p>{this.lbl('invoice.vehicle.label')}</p>;
    }

    return (
      <Link target="_blank" onClick={this.tofn(`/vehicles/${this.invoice.vehicle.id}`)}>
        {this.invoice.vehicle.description}
      </Link>
    );
  }

  onRelatedInvoiceClick(url) {
    return this.tofn(url)();
  }

  getVehicleId = () => this.state.selectedVehicle?.id ?? this.props.invoice?.vehicleId ?? this.props.invoice?.vehicle?.id;

  cancelBpmUpdate = () => {
    this.setState({ showConfirmBpmModal: false, isFinal: false });
  };

  confirmBpmUpdate = () => {
    this.setState({ showConfirmBpmModal: false, isFinal: true });
  };
  renderConfirmBpmModal = () => {
    return (
      <Modal title={this.lbl('invoice.details.warning')}>
        {this.lbl('invoice.details.diffWarning')}
        <ModalControls>
          <Button onClick={this.cancelBpmUpdate}>{this.lbl('invoice.filter.no')}</Button>
          <Button onClick={this.confirmBpmUpdate}>{this.lbl('invoice.filter.yes')}</Button>
        </ModalControls>
      </Modal>
    );
  };

  sanitizeValue(raw) {
    return raw === '' ? null : raw;
  }
  financialAmountsDto = bpmUpdate => {
    const vehicleSubject = this.vehicleSubject;
    if (!vehicleSubject) return;

    const subject = {
      id: this.getFieldValue('id'),
      costType: this.getFieldValue('costType'),
      direction: this.getFieldValue('direction'),
      incomingCompanyId: this.getFieldValue('incomingCompanyId'),
      outgoingCompanyId: this.getFieldValue('outgoingCompanyId'),
      subject_type: this.getFieldValue('subjectType'),
      vehicleId: this.getVehicleId(),
      vatCode: vehicleSubject?.subjectVat?.code,
      financialAmounts: {
        financial_purchase_price_marge_bpm: vehicleSubject?.financial_purchase_price_marge_bpm ?? null,
        financial_purchase_price_marge_excl_bpm: vehicleSubject?.financial_purchase_price_marge_excl_bpm ?? null,
        financial_purchase_price_incl_vat_bpm:
          vehicleSubject?.financial_purchase_price_incl_vat_bpm ?? vehicleSubject?.price ?? null,
        financial_purchase_price_incl_vat_excl_bpm: vehicleSubject?.financial_purchase_price_incl_vat_excl_bpm ?? null,
        financial_purchase_price_excl_vat_excl_bpm: vehicleSubject?.financial_purchase_price_excl_vat_excl_bpm ?? null,
        financial_price_marge_incl_bpm:
          vehicleSubject?.financial_purchase_price_excl_vat_excl_bpm ?? vehicleSubject?.price ?? null,
        outgoing_rest_bpm: bpmUpdate?.outgoing_rest_bpm ?? vehicleSubject?.outgoing_rest_bpm ?? null,
        financial_price_incl_vat_bpm: vehicleSubject?.financial_price_incl_vat_bpm ?? vehicleSubject?.price ?? null,
        financial_price_incl_vat_excl_bpm: vehicleSubject?.financial_price_incl_vat_excl_bpm ?? null,
        financial_price_excl_vat_excl_bpm: vehicleSubject?.financial_price_excl_vat_excl_bpm ?? null,
        financial_price_marge_excl_bpm: vehicleSubject?.financial_price_marge_excl_bpm ?? null,
        cost_price_excl_vat: vehicleSubject?.cost_price_excl_vat ?? null,
        cost_price_incl_vat: vehicleSubject?.cost_price_incl_vat ?? vehicleSubject?.price ?? null,
        bpm_price_excl_vat: vehicleSubject?.bpm_price_excl_vat ?? null,
        bpm_price_incl_vat: vehicleSubject?.bpm_price_incl_vat ?? vehicleSubject?.price ?? null,
        bpm_marge_price: vehicleSubject?.bpm_marge_price ?? vehicleSubject?.price ?? null,
        rest_bpm: bpmUpdate?.rest_bpm ?? vehicleSubject?.rest_bpm ?? null,
      },
      salesAmounts: {
        outgoing_rest_bpm: bpmUpdate?.outgoing_rest_bpm ?? vehicleSubject?.outgoing_rest_bpm ?? null,
        financial_price_incl_vat_bpm: vehicleSubject?.financial_price_incl_vat_bpm ?? vehicleSubject?.price ?? null,
        financial_price_incl_vat_excl_bpm: vehicleSubject?.financial_price_incl_vat_excl_bpm ?? null,
        financial_price_excl_vat_excl_bpm: vehicleSubject?.financial_price_excl_vat_excl_bpm ?? null,
        financial_price_marge_excl_bpm: vehicleSubject?.financial_price_marge_excl_bpm ?? null,
        cost_price_excl_vat: vehicleSubject?.cost_price_excl_vat ?? null,
        cost_price_incl_vat: vehicleSubject?.cost_price_incl_vat ?? vehicleSubject?.price ?? null,
        bpm_price_excl_vat: vehicleSubject?.bpm_price_excl_vat ?? null,
        bpm_price_incl_vat: vehicleSubject?.bpm_price_incl_vat ?? vehicleSubject?.price ?? null,
        bpm_marge_price: vehicleSubject?.bpm_marge_price ?? vehicleSubject?.price ?? null,
        financial_price_marge_incl_bpm: vehicleSubject?.financial_price_marge_incl_bpm ?? vehicleSubject?.price ?? null,
      },
    };

    if (subject.direction === INVOICE_DIRECTIONS.INCOMING) {
      subject.salesAmounts = {};
    }

    Object.entries(subject).forEach(([key, value]) => {
      subject[key] = this.sanitizeValue(value);
    });

    Object.entries(subject.financialAmounts).forEach(([key, value]) => {
      subject.financialAmounts[key] = this.sanitizeValue(value);
    });

    return subject;
  };
  calculateFinancialAmounts(bpmUpdate, forFinal) {
    const dto = this.financialAmountsDto(bpmUpdate);
    const vehicleId = this.getVehicleId();
    console.log(bpmUpdate);
    const [bpmName, newRestBpm] = Object.entries(bpmUpdate)[0];
    const params = [
      {
        propertyName: bpmName,
        propertyValue: newRestBpm,
      },
    ];
    this.props.updateRestBpmRequest(vehicleId, params, () => {
      this.props.calculateFinancialAmounts(dto, result => {
        console.log('CALC: ', result);
        const propNames = Object.keys(result)?.filter(
          pn =>
            result[pn] !== null &&
            !['subjectVat', 'vehicleId', 'type', 'btwOrMarge', 'rest_bpm', 'outgoing_rest_bpm'].includes(pn),
        );
        console.log(propNames);

        const params = propNames.map(pn => ({
          propertyName: pn,
          propertyValue: result[pn],
        }));

        const subjectId = this.vehicleSubject?.id;
        const subject = this.vehicleSubject ? { ...this.vehicleSubject, ...result } : { ...result };
        this.props.updateInvoiceSubject(subject, subjectId, () => {
          this.props.fetchInvoice();
          this.props.updateRestBpmRequest(vehicleId, params, result => {
            if (forFinal) {
              const restBpm = +result?.find(p => p?.propertyName?.name === 'rest_bpm')?.propertyValue?.value ?? null;
              const outgoingBpm =
                +result?.find(p => p?.propertyName?.name === 'outgoing_rest_bpm')?.propertyValue?.value ?? null;

              if (!!restBpm && !!outgoingBpm) {
                if (Math.abs(restBpm - outgoingBpm) > 200) {
                  this.setState({ showConfirmBpmModal: true });
                  return;
                }
              }
            }
          });
        });
      });
    });
  }

  handleCalculateInputChange(bpmUpdate, forFinal) {
    this._t = this.timeout(this.calculateFinancialAmounts.bind(this, bpmUpdate, forFinal), 1000, this._t);
  }

  syncRestBpm = (forFinal = false) => {
    const vehicleId = this.getVehicleId();
    if (!vehicleId) return;
    this.props.getCurrentRestBpm(vehicleId, result => {
      const vehicleId = this.getVehicleId();
      const newRestBpm =
        !isNaN(parseFloat(result?.autotelexRestBpm)) && !isNaN(result?.autotelexRestBpm - 0)
          ? +result?.autotelexRestBpm
          : null;
      if (!!newRestBpm && !!vehicleId) {
        const bpmName = this.getFieldValue('direction') === 'incoming' ? 'rest_bpm' : 'outgoing_rest_bpm';
        const bpmUpdate = { [bpmName]: newRestBpm };

        this.handleCalculateInputChange(bpmUpdate, forFinal);
      }
    });
  };

  renderUpdateDateBtn() {
    const originDate = this.props?.invoice?.date ? dayjs(this.props?.invoice?.date).format('YYYY-MM-DD') : null;
    const currentDate = this.getFieldValue('date') ? dayjs(this.getFieldValue('date')).format('YYYY-MM-DD') : null;
    console.log('currentDate', currentDate);
    console.log('originDate', originDate);
    const dateChanged = currentDate && originDate !== currentDate;
    return (
      dateChanged && (
        <Button
          small
          onClick={() => {
            this.props.updateInvoiceDate(this.getFieldValue('date'));
          }}
        >
          <Check />
        </Button>
      )
    );
  }

  onConfirmBPMModal(value) {
    this.setState({ bpmUpdateModal: false });
    this.props.updateInvoiceOutgoingBpm(value, data => {
      if (data.success) this.props.finalizeV2();
    });
  }
  renderOutgoingBPMModal() {
    if (!this.state.bpmUpdateModal) return '';
    return (
      <OutgoingBPMModal
        invoice={this.invoice}
        onConfirm={this.onConfirmBPMModal.bind(this)}
        onCancel={() => this.setState({ bpmUpdateModal: false })}
      />
    );
  }

  handleAddNewProductToInvoiceClick = () => {
    this.setState({ showAddProduct: true });
  };

  onSubjectComplete() {
    this.setState({ showAddProduct: false });
    this.to(`/invoices/${this.props.invoice_id}`);
  }

  onSubjectUpdateComplete() {
    this.setState({ showEditProduct: false });
    this.to(`/invoices/${this.props.invoice_id}`);
  }

  get editDisabled() {
    return this.invoice.isFinal;
  }

  renderRow(s) {
    return (
      <Row onClick={() => this.setState({ showEditProduct: true, currentSubject: s })}>
        <HBox vCenter>
          <HBox style={{ width: '50%' }}>
            <div>{s.description}</div>
            <div>{s.product_price_incl_vat}</div>
          </HBox>
          <Button disabled={this.editDisabled} onClick={() => this.props.deleteSubject(s.id)} small isPrimary>
            {<Times />}
          </Button>
        </HBox>
      </Row>
    );
  }

  render() {
    if (
      this.props.work ||
      this.props.workExport ||
      this.props.workDecline ||
      this.props.workSyncBPM ||
      this.props.workCredit ||
      this.props.workUpdateBPM ||
      !this.props.invoice
    )
      return <Loader small />;
    if (this.props.workDelete) {
      return <LoadingWithNotification message={this.lbl('invoice.details.delete_order_notification')} />;
    }
    // if (parseInt(this.props?.invoice_id) !== this.props?.invoice?.id && this.props?.invoice?.id) {
    //   this.props.fetchInvoice();
    // }
    return (
      <Container>
        {this.renderIncomingCompanyEdit()}
        {this.renderOutgoingCompanyEdit()}
        {this.renderDirectionEdit()}
        {this.renderTypeEdit()}
        {this.renderStatusEdit()}
        {this.renderBpmWarningModal()}
        {this.renderOutgoingBPMModal()}
        {!!this.state.showConfirmBpmModal && this.renderConfirmBpmModal()}
        {this.state.showViesCheckPrompt && (
          <ViesCheckPrompt onConfirm={this.onUpdate.bind(this)} onCancel={this.reset.bind(this)} />
        )}
        {!!this.state.showQuizCredit && (
          <InvoiceQuizModal
            direction={this.invoice.direction}
            vehicle={this.vehicleSubject?.vehicle}
            onConfirm={this.sendCreditRequest}
            onCancel={this.onCancelQuiz}
          />
        )}
        {!!this.state.showQuizDelete && (
          <InvoiceQuizModal
            direction={this.invoice.direction}
            vehicle={this.vehicleSubject?.vehicle}
            onConfirm={this.sendDeleteRequest}
            onCancel={this.onCancelQuiz}
          />
        )}
        <h3>
          {this.lbl('invoice.details.title')} {this.props?.invoice?.entryNumber}
        </h3>
        <Content>
          <FormFields>
            <HBox>
              <VBox>
                <p>{this.lbl('invoice.create.date')}</p>
                <FormField>
                  <DatePicker
                    dateFormat="dd-MM-yyyy"
                    selected={this.getFieldValue('date') && dayjs(this.getFieldValue('date')).toDate()}
                    onChange={this.onDateChange.bind(this)}
                  />
                  {this.renderUpdateDateBtn()}
                </FormField>
              </VBox>
              <VBox>
                <p>{this.lbl('invoice.create.dueDate')}</p>
                <FormField>
                  <DatePicker
                    dateFormat="dd-MM-yyyy"
                    selected={this.getFieldValue('dueDate') && dayjs(this.getFieldValue('dueDate')).toDate()}
                    onChange={this.onDueDateChange.bind(this)}
                  />
                </FormField>
              </VBox>
            </HBox>
            <HBox>
              <VBox>
                <p>{this.lbl('invoice.create.paidDate')}</p>
                <FormField>
                  <DatePicker
                    dateFormat="dd-MM-yyyy"
                    selected={this.getFieldValue('paidDate') && dayjs(this.getFieldValue('paidDate')).toDate()}
                    onChange={this.onPaidDateChange.bind(this)}
                  />
                </FormField>
              </VBox>
              <VBox>
                <p>{this.lbl('invoice.create.desiredDeliveryDate')}</p>
                <FormField>
                  <DatePicker
                    dateFormat="dd-MM-yyyy"
                    selected={
                      this.getFieldValue('desiredDeliveryDate') && dayjs(this.getFieldValue('desiredDeliveryDate')).toDate()
                    }
                    onChange={this.onDesiredDeliveryDateChange.bind(this)}
                  />
                </FormField>
              </VBox>
            </HBox>
            <HBox>
              <VBox>
                <p>{this.lbl('invoice.create.incoming')}</p>
                <FormField>
                  <Input
                    name="incoming"
                    value={this.getFieldValue('incoming') ?? ''}
                    onChange={this.onInputChange.bind(this)}
                  />
                </FormField>
              </VBox>
              <VBox>
                <p>{this.lbl('invoice.create.payments')}</p>
                <FormField>
                  <Input
                    name="payments"
                    value={this.getFieldValue('payments') ?? ''}
                    onChange={this.onInputChange.bind(this)}
                  />
                </FormField>
              </VBox>
            </HBox>
            <HBox>
              <VBox>
                <p>{this.lbl('invoice.create.creator')}</p>
                <FormField>{this.renderCreator()}</FormField>
              </VBox>
            </HBox>
            <HBox>
              <VBox>
                <p>{this.lbl('invoice.create.direction')}</p>
                <FormField>{this.renderDirection()}</FormField>
              </VBox>
              {this.renderCompany()}
            </HBox>
            {this.renderTransportLocationSection()}
            <HBox>
              <VBox>
                <p>{this.lbl('invoice.create.type')}</p>
                <FormField>{this.renderType()}</FormField>
              </VBox>
            </HBox>
            <HBox>
              <VBox>
                <VBox>
                  <p onClick={this.onEditStatus.bind(this)}>{this.lbl('invoice.create.status')}</p>
                  <FormField>{this.renderStatus()}</FormField>
                  <PaymentsLog invoice={this.invoice} />
                </VBox>
                <HBox>
                  <FormField>{this.renderDeclined()}</FormField>
                </HBox>
              </VBox>
              <VBox>
                <p>{this.lbl('invoice.create.finalized')}</p>
                <Checkbox checked={this.getFieldValue('isFinal')}></Checkbox>
              </VBox>
            </HBox>
            <HBox>
              {this.props.invoice.subjectType === INVOICE_SUBJECT_TYPES.PRODUCT && (
                <HBox>
                  <Button small disabled={this.editDisabled} onClick={this.handleAddNewProductToInvoiceClick.bind(this)}>
                    {this.lbl('add_new_product')}
                  </Button>
                  {this.state.showAddProduct && (
                    <ProductSubjectDetails
                      invoice={this.invoice}
                      vehicle={this.vehicle}
                      onClose={() => this.setState({ showAddProduct: false })}
                      onComplete={this.onSubjectComplete.bind(this)}
                      taxRegion={this.invoice?.taxRegion}
                    />
                  )}
                  {this.state.showEditProduct && (
                    <ProductSubjectDetails
                      editDisabled={this.editDisabled}
                      invoice={this.invoice}
                      vehicle={this.vehicle}
                      onClose={() => this.setState({ showEditProduct: false })}
                      onComplete={this.onSubjectUpdateComplete.bind(this)}
                      editMode={true}
                      currentSubject={this.state.currentSubject}
                      taxRegion={this.invoice?.taxRegion}
                    />
                  )}
                  <VBox>{this.invoice.invoiceSubjects.map(s => this.renderRow(s))}</VBox>
                </HBox>
              )}
              {this.props.invoice.subjectType !== INVOICE_SUBJECT_TYPES.PRODUCT && (
                <VBox>
                  <p>{this.lbl('invoice.subject.title')}</p>
                  <FormField>
                    <InvoiceSubjectContainer
                      items={this.getFieldValue('invoiceSubjects')}
                      onSaveSubject={this.onSaveSubject.bind(this)}
                      onDeleteSubject={this.onDeleteSubject.bind(this)}
                      direction={this.getFieldValue('direction')}
                      incomingCompanyId={this.getFieldValue('incomingCompanyId')}
                      outgoingCompanyId={this.getFieldValue('outgoingCompanyId')}
                    />
                  </FormField>
                </VBox>
              )}
              <VBox>
                <p>{this.lbl('invoice.relationSource.title')}</p>
                <FormField>
                  <InvoiceRelationSourceContainer
                    items={this.getFieldValue('relationSources')}
                    onAddSource={this.onAddSource.bind(this)}
                    onDeleteSource={this.onDeleteSource.bind(this)}
                  />
                </FormField>
              </VBox>
            </HBox>
            <HBox>
              <VBox>
                <p>{this.lbl('invoice.invoiceAddittionalLines.extraComment')}</p>
                <FormField>
                  <Input
                    name="extra_comment"
                    value={(this.state.extraComment || this.props.invoice.invoiceAdditionalLines[0]?.value) ?? ''}
                    onChange={this.onChangeComment.bind(this)}
                  />
                </FormField>
              </VBox>
            </HBox>
            <HBox>
              <VBox>
                <p>{this.lbl('invoice.vehicle.label')}</p>
                <FormField>{this.renderAttachedVehicle()}</FormField>
              </VBox>
            </HBox>
            <HBox>
              <VBox>
                <p>{this.lbl('invoice.details.referenceNumber')}</p>
                <FormField>
                  <Input
                    name="referenceNumber"
                    value={this.getFieldValue('referenceNumber') ?? ''}
                    onChange={this.onInputChange.bind(this)}
                  />
                </FormField>
              </VBox>
              <VBox></VBox>
            </HBox>
            <HBox>
              <VBox>
                <p>{this.lbl('invoice.create.financialTotalAmount')}</p>
                <FormField>
                  <Input
                    disabled={true}
                    name="financialTotalAmount"
                    value={this.getFieldValue('financialTotalAmount') ?? ''}
                    onChange={this.onInputChange.bind(this)}
                  />
                </FormField>
              </VBox>
              <VBox>
                <p>{this.lbl('invoice.create.economicalTotalAmount')}</p>
                <FormField>
                  <Input
                    disabled={true}
                    name="economicalTotalAmount"
                    value={this.getFieldValue('economicalTotalAmount') ?? ''}
                    onChange={this.onInputChange.bind(this)}
                  />
                </FormField>
              </VBox>
            </HBox>
            <HBox>{this.renderSyncBpmSection()}</HBox>
            <HBox>
              <LedgersPosting ledgersEntry={this.invoice.ledgersEntry} invoice={this.invoice}></LedgersPosting>
            </HBox>
            <HBox>
              <VBox>
                <InvoiceStructureCard invoice={this.invoice} onRelatedInvoiceClick={this.onRelatedInvoiceClick.bind(this)} />
              </VBox>
            </HBox>
            <HBox flip={window.innerWidth <= 768} vCenter spaceAround>
              <VBox left style={{ maxWidth: 225 }}>
                <Button onClick={() => this.syncRestBpm(false)}>{this.lbl('invoice.details.syncRestBpm')}</Button>
              </VBox>
              <VBox left style={{ maxWidth: 225 }}>
                {this.renderExportSection()}
                {this.renderDeclineSection()}
                {this.renderCreditSection()}
                <Permission permission={INVOICE_DELETE}>{this.renderDeleteSection()}</Permission>
              </VBox>
            </HBox>
          </FormFields>
        </Content>
        <HBox>
          <Button primary disabled={this.props.workViesCheck} onClick={this.reset.bind(this)}>
            {this.lbl('invoice.create.reset')}
          </Button>
          <Permission permission={INVOICE_EDIT}>
            <Button
              primary
              disabled={this.applyDisabled}
              onClick={
                this.state.getViesCheck && this.invoice?.subjectType !== INVOICE_SUBJECT_TYPES?.BPM
                  ? this.onViesCheck.bind(this)
                  : this.onUpdate.bind(this)
              }
            >
              {this.props.workViesCheck ? <Loader small /> : this.lbl('invoice.details.updateBtn')}
            </Button>
          </Permission>
        </HBox>
        {this.state.showEmailModal && (
          <ProductInvoiceEmailModal
            invoice={this.invoice}
            onComplete={this.onEmailModalComplete.bind(this)}
            onClose={() => this.setState({ showEmailModal: false })}
          />
        )}
      </Container>
    );
  }
}

InvoiceDetailsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    invoice: selectInvoice(),
    vehicle: id => selectVehicle(id),
    syncedBpm: selectAutotelexBPM(),
    work: selectWork(REQUEST_INVOICE, REQUEST_EXACT_AUTH_STATUS),
    workAuthStatus: selectWork(REQUEST_EXACT_AUTH_STATUS),
    workExport: selectWork(REQUEST_EXACT_EXPORT_INVOICE),
    workDecline: selectWork(REQUEST_INVOICE_DECLINE),
    workDelete: selectWork(REQUEST_INVOICE_DELETE),
    workSyncBPM: selectWork(REQUEST_SYNC_BPM),
    workCredit: selectWork(REQUEST_CREATE_CREDIT_INVOICE),
    workViesCheck: selectWork(REQUEST_VIES_CHECK),
    workUpdateBPM: selectWork(REQUEST_UPDATE_INVOICE_OUTGOING_BPM),
    serverConfig: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    update(dto, callback) {
      dispatch(updateInvoice(ownProps.invoice_id, dto, callback));
    },
    fetchInvoice() {
      dispatch(fetchInvoice(ownProps.invoice_id));
    },
    fetchVehicle(vehicleId) {
      if (!vehicleId) return;
      dispatch(fetchVehicle(vehicleId));
    },
    updateRestBpmRequest(vehicleId, params, callback) {
      dispatch(updateRestBpmRequest(ownProps.invoice_id, vehicleId, params, callback));
    },
    addRelationSource(data, callback) {
      const sanitizedData = { ...data, id: undefined };
      dispatch(addRelationSource(sanitizedData, ownProps.invoice_id, callback));
    },
    removeRelationSource(sourceId, callback) {
      dispatch(removeRelationSource(sourceId, ownProps.invoice_id, callback));
    },
    removeInvoiceSubject(subjectId, callback) {
      dispatch(removeInvoiceSubject(subjectId, ownProps.invoice_id));
    },
    exportInvoiceToExact() {
      dispatch(exportInvoiceToExact(ownProps.invoice_id));
    },
    finalizeV2() {
      dispatch(finalizeV2(ownProps.invoice_id));
    },
    retryFinalizationV2() {
      dispatch(retryFinalizationV2(ownProps.invoice_id));
    },
    getExactAuthStatus(callback) {
      dispatch(getExactAuthStatus(callback));
    },
    addInvoiceSubject(subject) {
      dispatch(addInvoiceSubject(subject, ownProps.invoice_id));
    },
    updateInvoiceSubject(subject, subjectId, callback) {
      dispatch(updateInvoiceSubject(subject, ownProps.invoice_id, subjectId, callback));
    },
    updateInvoiceStatus(statusId, callback) {
      dispatch(updateInvoiceStatus(ownProps.invoice_id, statusId, callback));
    },
    showError(error) {
      dispatch(addApiError(error));
    },
    declineInvoice() {
      dispatch(declineInvoice(ownProps.invoice_id));
    },
    deleteInvoice(properties, callback, vehicleId) {
      dispatch(deleteInvoice(ownProps.invoice_id, callback, properties, vehicleId));
    },
    syncBpm() {
      dispatch(syncBpm(ownProps.invoice_id));
    },
    createCreditInvoice(properties, callback) {
      dispatch(createCreditInvoice(ownProps.invoice_id, properties, callback));
    },
    getCurrentRestBpm(vehicleId, callback) {
      dispatch(getCurrentRestBpm(vehicleId, callback));
    },
    updateInvoiceDate(date) {
      dispatch(updateInvoiceDate(ownProps.invoice_id, date));
    },
    checkViesStatus(dto, callback) {
      dispatch(checkVies(dto, callback));
    },
    calculateFinancialAmounts(subject, callback) {
      dispatch(calculateFinancialAmounts(subject, callback));
    },
    updateInvoiceOutgoingBpm(value, callback) {
      dispatch(updateInvoiceOutgoingBpm(ownProps.invoice_id, value, callback));
    },
    deleteSubject: subjectId => {
      dispatch(removeInvoiceSubject(subjectId, ownProps.invoice_id));
    },
    updateInvoiceEmailData: (dto, callback) => {
      dispatch(updateInvoiceEmailData(ownProps.invoice_id, dto, callback));
    },
    addApiError(msg) {
      dispatch(addApiError(msg));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const InvoiceDetails = compose(withConnect, withRouter)(InvoiceDetailsComp);
